export const featureFlagSlugs = {
  transportMagicLinkLogin: 'transport_magic_link_login',
  pricePerMile: 'load_board_price_per_mile',
  instantBook: 'transport_instant_book',
};
